
import React, { useState } from 'react';
import ShiftContextMenu from './ShiftContextMenu';


const CustomEvent = ({ event, setHasCopiedShift }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuPos, setMenuPos] = useState({ x: 0, y: 0 });

  const closeMenu = () => {
    setMenuVisible(false);
  };
  

  const handleContextMenu = (e) => {
    e.preventDefault();
    e.stopPropagation();


    const x = e.clientX;
    const y = e.clientY;
    setTimeout(() => {
      setMenuPos({ x, y });
      setMenuVisible(true);
    }, 0);
  };


  return (
    <>
      <div
        onContextMenu={handleContextMenu}
        style={{
    
          width: '100%',
          height: '100%',
          zIndex: 1,               
          pointerEvents: 'auto',  
          userSelect: 'none',
          cursor: 'context-menu',

        }}
      >
        {event.title}
      </div>
      {menuVisible && (
        <>
          {console.log("🎯 Renderizando menú de COPY")}
          <ShiftContextMenu
            x={menuPos.x}
            y={menuPos.y}
            onClose={closeMenu}
            shiftData={event}
            setHasCopiedShift={setHasCopiedShift}
            
          />
        </>
      )}

    </>

  );
};

export default CustomEvent;


